'use client';

import { useEffect, useState } from 'react';

export type TelegramInsets = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

const ZERO_INSETS: TelegramInsets = { top: 0, right: 0, bottom: 0, left: 0 };

function toNumber(value: unknown): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

function readInsets(): TelegramInsets {
  if (typeof window === 'undefined') return ZERO_INSETS;

  const webApp = (window as Window & { Telegram?: { WebApp?: any } }).Telegram?.WebApp;
  if (!webApp) return ZERO_INSETS;

  const source = webApp.contentSafeAreaInset ?? webApp.safeAreaInset ?? {};

  return {
    top: toNumber(source.top),
    right: toNumber(source.right),
    bottom: toNumber(source.bottom),
    left: toNumber(source.left),
  };
}

export function useTelegramInsets(): TelegramInsets {
  const [insets, setInsets] = useState<TelegramInsets>(ZERO_INSETS);

  useEffect(() => {
    const update = () => setInsets(readInsets());

    update();

    const webApp = (window as Window & { Telegram?: { WebApp?: any } }).Telegram?.WebApp;
    webApp?.onEvent?.('safeAreaChanged', update);
    window.addEventListener('resize', update);

    return () => {
      webApp?.offEvent?.('safeAreaChanged', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return insets;
}
